import { Box, FormHelperText } from "@mui/material";
import React from "react";
import CustomSelect from "./CustomSelect";

const CustomSelectVerify = ({ ...props }) => {
  const [error, setError] = React.useState(false);
  const { required, helperText } = props;
  const handleOnblur = (e: any) => {
    if (required && e.target.value == "") {
      e.target.error = true;
      setError(true);
    } else {
      setError(false);
    }
  };
  let helperTextValue = helperText?.toString() || "This field is required";
  if (helperText === "no") {
    helperTextValue = "";
  }
  return (
    <Box>
      <CustomSelect {...props} error={error} onBlur={handleOnblur} />
      {error && helperTextValue && (
        <FormHelperText sx={{ color: "#d32f2f", marginLeft: "14px" }}>
          {helperTextValue}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CustomSelectVerify;
